export default {
    "NotSupportFile": "File not supported, please try another one.",
    "LoginWithGoogle": "Login with Google",
    "SignUpWithGoogle": "Sign up with Google",
    "BachFileNoLimit": "Batch Process Large Files With NO Size Limit",
    "ConvertVideoTo300Formats": "One Click Convert Video to 300+ Audio Formats",
    "120XDownloadSites": "120X Faster Download Audio from 10000+ Hot Sites",
    "DownloadDesktopToExtract": "Download desktop version to extract audio from YouTube,and other 10000+sites",
    "DownloadDesktopNoLimit": "Download Desktop Version to Batch Process Large Files With NO Size Limit",
    "BachThousandOfFormats": "Batch convert video and audio files to 1000+ formats with 120X faster speed",
    "DownloadVIdeoByThousandsOfSites": "Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.",
    "RichEditingFeatures": "Built-in rich video editing features: merge, cut, crop, watermark, etc.",
    "ConvertMusicWithDrm": "Convert Apple Music to MP3 with DRM removed (Windows version only)",
    "Try It Free": "Try It Free",
    "NotNow": "Not Now",
    "300Formats": "300+ Formats",
    "Convert300FormatsByDesktop": "Use desktop audio converter to convert videos to 300+ audio formats",
    "ExtractingAudio": "Extracting Audio...",
    "120XFasterToConvert": "120X Faster Convert Videos to Audio in HitPaw Video Converter",
    "FailedToExtract": "Failed to extract audio, try to get audio from video using powerful HitPaw Video Converter.",
    "SureToStopExtract": "Are you sure to stop extracting audio?",
    "Cancel": "Cancel",
    "Stop": "Stop",
    "DownloadAudio": "Downloading Audio...",
    "120XDownloadVideoFromWebsites": "120X Faster Download Audio from 10000+ Websites in HitPaw Video Converter",
    "SureToStopDownload": "Are you sure to stop downloading audio?",
    "ExtractingAudioInThousandsSites": "Extract audio from YouTube and other 10000+ sites using powerful HitPaw Video Converter.",
    "Upload New Video": "Upload New Video",
    "Download": "Downloading...",
    "Download Successful": "Download Successful!",
    "Failed to download": "Failed to download.",
}